import { render } from "./CustomSelectOneSemenOrigin.vue?vue&type=template&id=73daf82c"
import script from "./CustomSelectOneSemenOrigin.vue?vue&type=script&lang=js"
export * from "./CustomSelectOneSemenOrigin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__